// src/pages/Modules/SmartPointModule.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Grid, CardActionArea, CircularProgress } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StarsIcon from '@mui/icons-material/Stars';
import { usePermissions } from '../../context/PermissionContext';
import BackButton from '../../components/BackButton';

const cardOptions = [
  {
    title: 'CUSTOMER SMART POINT MANAGE',
    icon: <StarsIcon sx={{ fontSize: 50, color: 'primary.main' }} />,
    path: '/smart-point/customer-smart-point-manage',
    perm: 'smartPoint.points',
    description: 'Search customers, add/deduct smart points (Credit/Debit), and view smart points transaction history'
  },
  {
    title: 'CUSTOMER WELFARE MANAGE',
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 50, color: 'success.main' }} />,
    path: '/smart-point/customer-welfare-manage',
    perm: 'smartPoint.welfare',
    description: 'Search customers, add/deduct Welfare Fund (Credit/Debit), and view Welfare Fund transaction history'
  },
  {
    title: 'WITHDRAWAL MANAGEMENT',
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 50, color: 'secondary.main' }} />,
    path: '/withdrawal-management',
    perm: 'smartPoint.withdrawals',
    description: 'View and process customer withdrawal requests'
  }
];

const SmartPointModule = () => {
  const { can, loading } = usePermissions();
  const navigate = useNavigate();

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh' }}>
        <CircularProgress />
      </Grid>
    );
  }

  return (
    <Box sx={{ position: 'relative', padding: 3 }}>
      <BackButton />
      <Box sx={{ p: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 3 }}>
          SMART POINT MODULE
        </Typography>
        <Grid container spacing={3}>
          {cardOptions.map((card, index) => {
            const accessible = can(card.perm);
            if (!accessible) return null;

            return (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <Card 
                  elevation={3} 
                  sx={{ 
                    height: '100%', 
                    borderRadius: 3, 
                    transition: '0.3s', 
                    '&:hover': { transform: 'translateY(-4px)', boxShadow: 6 } 
                  }}
                >
                  <CardActionArea onClick={() => navigate(card.path)} sx={{ height: '100%', p: 2 }}>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                      <Box sx={{ mb: 2 }}>
                        {card.icon}
                      </Box>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {card.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {card.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default SmartPointModule;
